export default __webpack_public_path__ + "static/media/Winter_14.4e51b2a1.png";